function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "ruby_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "ruby_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ruby_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "ruby-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "ruby-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ruby_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(8.876953 14.0625)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.878905 0C0.394628 0 0 0.394628 0 0.878905C0 1.36318 0.394628 1.75781 0.878905 1.75781L3.16406 1.75781C3.64833 1.75781 4.04296 1.36318 4.04296 0.878905C4.04296 0.394628 3.64833 0 3.16406 0L0.878905 0Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.914 0.351562C36.748 0.130166 36.4875 0 36.2109 0L8.78905 0C8.51245 0 8.25195 0.130166 8.08592 0.351562C8.08592 0.351562 0.176484 10.8987 0.176748 10.8988C0.0663573 11.0457 0 11.2278 0 11.4258L0 18.457C0 18.6728 0.0780467 18.8701 0.20707 19.0231C0.206982 19.0232 21.8278 44.6874 21.8278 44.6874C21.9947 44.8856 22.2407 45 22.4999 45C22.7591 45 23.0051 44.8856 23.172 44.6874C23.172 44.6874 44.7928 19.0232 44.7927 19.0231C44.9219 18.8701 44.9999 18.6728 44.9999 18.457L44.9999 11.4258C44.9999 11.2278 44.9337 11.0458 44.8233 10.8989C44.8236 10.8987 36.914 0.351562 36.914 0.351562ZM42.3632 10.5469L31.0666 10.5469L36.3235 2.4938L42.3632 10.5469ZM29.4433 9.81789L24.182 1.75781L34.7048 1.75781L29.4433 9.81789ZM28.5644 15.8203L28.5644 17.5781L16.5527 17.5781L16.5527 12.3047L28.5644 12.3047L28.5644 14.0625L27.0993 14.0625C26.6149 14.0625 26.2204 14.4571 26.2204 14.9414C26.2204 15.4257 26.615 15.8203 27.0994 15.8203L28.5644 15.8203ZM17.2971 10.5469L22.5586 2.48677L27.8201 10.5469L17.2971 10.5469ZM15.6739 9.81789L10.4125 1.75781L20.9353 1.75781L15.6739 9.81789ZM14.0505 10.5469L2.63671 10.5469L8.73912 2.41031L14.0505 10.5469ZM14.7949 12.3047L14.7949 17.5781L1.75781 17.5781L1.75781 12.3047L14.7949 12.3047ZM14.9409 19.3359L20.6279 40.5348L2.76855 19.3359L14.9409 19.3359ZM16.761 19.3359L28.2391 19.3359L22.5 40.7289L16.761 19.3359ZM30.059 19.3359L42.2314 19.3359L24.3719 40.5348L30.059 19.3359ZM36.4745 14.0625C35.9903 14.0625 35.5956 14.4571 35.5956 14.9414C35.5956 15.4257 35.9903 15.8203 36.4745 15.8203L43.2421 15.8203L43.2421 17.5781L30.3222 17.5781L30.3222 12.3047L43.2421 12.3047L43.2421 14.0625L36.4745 14.0625Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgRuby = function SvgRuby(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRuby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ruby.1a73af40.svg";
export { ForwardRef as ReactComponent };